import { FilterStates } from "@/Components/Filters";
import { useI18n } from "vue-i18n";
import route from "ziggy-js";
import { useFilters } from "@/Composables/useFilters";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { isEmpty } from "lodash";

export function useDefaultAssetsViews() {
    const { t } = useI18n();

    const globalFilterStore = useFilters("global");
    const { filterValues: globalFilterValues } = storeToRefs(globalFilterStore);

    const tenantId = computed(() => globalFilterValues.value.tenant?.[0] || "");

    const DefaultView = Object.freeze({
        ALL: {
            id: "all",
            name: t("admin.assets.views.all_assets"),
            default: true,
            filters: new FilterStates(),
            href: route("assets.index"),
        },
        ASSET_GROUPS: {
            id: "asset_groups",
            name: t("admin.assets.views.asset_groups"),
            default: true,
            filters: new FilterStates(),
            href: route("asset_groups.index"),
        },
    });

    const defaultViews = computed(() => {
        return !isEmpty(tenantId.value)
            ? [DefaultView.ALL, DefaultView.ASSET_GROUPS]
            : [DefaultView.ALL];
    });

    return {
        DefaultView,
        defaultViews,
    };
}
